import { Component, OnInit, Output, EventEmitter, Input, ViewChild, ElementRef } from '@angular/core';
import { LoadingController, AlertController } from '@ionic/angular';
import { BUSNQuestionService } from '@takectrl-multiapp/svcs-core-business';
import {
  AssetType,
  IMotorSaveObject,
  IQuestion,
  IResponseMotorVehicles,
  IVehicleMakeModel,
  IVheicleType,
  InputType,
  SharedConfig,
  UnderwritingAnswer,
} from '@takectrl-multiapp/svcs-share-config';
import * as _ from 'lodash';

interface ISplitBrand {
  popular?: string[];
  others?: string[];
}
@Component({
  // tslint:disable-next-line: component-selector
  selector: 'input-dropdown-motor-selector',
  standalone: false,
  templateUrl: './input-dropdown-motor-selector.component.html',
  styleUrls: ['./input-dropdown-motor-selector.component.scss'],
})

//TODO : when databse refactor, change vechicle to CAR.
export class InputDropdownMotorSelectorComponent implements OnInit {
  @Input() question: IQuestion;
  @Input() showHeading: boolean;
  @Input() error: string;
  @Input() readOnly: boolean;
  @Output() answerQuestion: EventEmitter<IQuestion> = new EventEmitter();
  @Input() labelPosition: string;
  @ViewChild('searchInputMakes') searchInputMakeRef: ElementRef<HTMLInputElement>;
  @ViewChild('searchInputModels') searchInputModelRef: ElementRef<HTMLInputElement>;
  public yearRegUnderwriting: UnderwritingAnswer = { object_answer: '' };
  public yearUnderwriting: UnderwritingAnswer = { object_answer: '' };
  public makeUnderwriting: UnderwritingAnswer = { object_answer: '' };
  public modelUnderwriting: UnderwritingAnswer = { object_answer: '' };
  public vehicleTypeUnderwriting: UnderwritingAnswer = { object_answer: '' };
  model_id: UnderwritingAnswer = { object_answer: '' };
  vehicleTypeCode: string;
  searchFound: Array<any> | undefined;


  popularMakes = [];

  listYear = [];
  makes: Array<string>;
  models: Array<IVehicleMakeModel>;
  modelVariants: Array<IResponseMotorVehicles>;
  vehicle_types: Array<IVheicleType>
  loader = this.loading.create();
  motor: Array<IMotorSaveObject>;
  popupHeading: string;
  selectArray = [];
  showSelectPopup = false;
  selectAnswer: string;
  constructor(public questionService: BUSNQuestionService, private readonly loading: LoadingController, private readonly alertCtrl: AlertController, private readonly sharedConfig: SharedConfig) {

  }

  async ngOnInit(): Promise<void> {
    this.sharedConfig.setShowCustomLoader(true)
    const vehicleTypeUnderwriting = _.cloneDeep(this.question.underwriting_answers.find((object_name) => object_name.object_field === 'vehicle_type'));
    const yearRegUnderwriting = _.cloneDeep(
      this.question.underwriting_answers.find((object_name) => object_name.object_field === 'year_of_registration')
    );
    const yearUnderwriting = _.cloneDeep(
      this.question.underwriting_answers.find((object_name) => object_name.object_field === 'year_of_manufacture')
    );
    const makeUnderwriting = _.cloneDeep(this.question.underwriting_answers.find((object_name) => object_name.object_field === 'make'));
    const modelUnderwriting = _.cloneDeep(this.question.underwriting_answers.find((object_name) => object_name.object_field === 'model'));
    // THIS IS MOCK DATA THAT NEED TO BE REMOVED /////
    // vehicleTypeUnderwriting.object_answer = 'Passenger Vehicle';
    // yearRegUnderwriting.object_answer = 2020;
    // yearUnderwriting.object_answer = 2020;
    // makeUnderwriting.object_answer = 'FORD';
    // modelUnderwriting.object_answer = 'EVEREST 2.0D XLT A/T';
    /////////////////////////////////////////////////////////
    if (
      typeof yearUnderwriting.object_answer !== InputType.number ||
      typeof yearRegUnderwriting.object_answer !== InputType.number ||
      typeof makeUnderwriting.object_answer !== 'string' ||
      typeof modelUnderwriting.object_answer !== 'string' || 
      typeof vehicleTypeUnderwriting.object_answer !== 'string'
    ) {
      delete yearUnderwriting.object_answer;
      delete yearRegUnderwriting.object_answer;
      delete makeUnderwriting.object_answer;
      delete modelUnderwriting.object_answer;
      delete vehicleTypeUnderwriting.object_answer;
    }

    // if (
    //   model &&
    //   yearUnderwriting &&
    //   modelUnderwriting &&
    //   makeUnderwriting &&
    //   makeUnderwriting.object_answer &&
    //   (makeUnderwriting.object_answer as string).length > 0
    // ) {
    //   const [makes, models, modelVariants] = await Promise.all([
    //     this.questionService.getVehicleMake(this.question.underwriting_answers[0].object_name),
    //     this.questionService.getVehicleModel(
    //       this.question.underwriting_answers[0].object_name,
    //       makeUnderwriting.object_answer,
    //       yearUnderwriting.object_answer
    //     ),
    //     this.questionService.getVehicleModelVariant(
    //       this.question.underwriting_answers[0].object_name,
    //       makeUnderwriting.object_answer,
    //       yearUnderwriting.object_answer,
    //       modelUnderwriting.object_answer
    //     ),
    //   ]);

    //   this.makes = makes;
    //   this.models = models;
    //   this.modelVariants = modelVariants;
    // }
    this.yearRegUnderwriting = yearRegUnderwriting;
    this.yearUnderwriting =  yearUnderwriting;
    this.makeUnderwriting = makeUnderwriting;
    this.modelUnderwriting = modelUnderwriting;
    this.vehicleTypeUnderwriting = vehicleTypeUnderwriting;
    if (SharedConfig.selectedPage !== 'summary' && this.yearUnderwriting.object_answer && this.makeUnderwriting.object_answer && this.modelUnderwriting.object_answer) {
      this.question.underwriting_answers = [
        this.vehicleTypeUnderwriting,
        this.yearRegUnderwriting,
        this.yearUnderwriting,
        this.makeUnderwriting,
        this.modelUnderwriting
      ];
      this.answerQuestion.emit(this.question); //<-- To enable next button
    }

    this.vehicle_types = await this.questionService.vehicleTypes();

    this.sharedConfig.setShowCustomLoader(false)
  }

  selectMakePopup() {
    this.showSelectPopup = true;
    SharedConfig.showFullScreen = true;
    this.popupHeading = 'Make';
    setTimeout(() => this.searchInputMakeRef?.nativeElement?.focus());
    this.searchFound = new Array;
    SharedConfig.addingClaim = true;
  }

  search(event: any, label: string) {
    switch (label) {
      case 'make':
        this.searchFound = this.makes?.filter((str: any) => str.description.toLowerCase().includes(event.target.value.toLowerCase()));
        break;
      case 'model':
        this.searchFound = this.models?.filter((str: any) => str.description.toLowerCase().includes(event.target.value.toLowerCase()));
        break;
      default:
        break;
    }
    
  }

  async showSelect(selectArray, heading) {
    console.log(selectArray)
    this.searchFound = new Array;
    this.showSelectPopup = true;
    SharedConfig.showFullScreen = true;
    this.selectArray = selectArray;
    this.popupHeading = heading;
    SharedConfig.addingClaim = true;
    const year = new Date().getFullYear();
    switch (this.popupHeading) {
      case 'Year of Manufacture':
        this.selectAnswer = this.yearUnderwriting.object_answer;
        this.selectArray = Array(30)
          .fill(0)
          // tslint:disable-next-line: radix
          .map((val, i) => parseInt(`${year - i}`));
        break;
      case 'Make':
        this.selectAnswer = this.makeUnderwriting.object_answer;
        setTimeout(() => this.searchInputMakeRef?.nativeElement?.focus());
        break;
      case 'Model':
        this.selectAnswer = this.modelUnderwriting.object_answer;
        setTimeout(() => this.searchInputModelRef?.nativeElement?.focus());
        break;
      case 'Vehicle Type':
        this.selectAnswer = this.vehicleTypeUnderwriting.object_answer;
        break;
      case 'Year of Registration':
        this.selectAnswer = this.yearRegUnderwriting.object_answer;
        this.selectArray = Array(30)
          .fill(0)
          // tslint:disable-next-line: radix
          .map((val, i) => parseInt(`${year - i}`));
        break;
      default:
        break;
    }
  }

  async setAnswer(answer) {
    this.searchFound = new Array;
    this.selectAnswer = answer;
    this.sharedConfig.setShowCustomLoader(true);
    switch (this.popupHeading) {
      case 'Year of Manufacture':
        this.onSelectYear(answer);
        setTimeout(() => {
          this.closeSelectPopup();
          this.sharedConfig.setShowCustomLoader(false)
          this.selectMakePopup()
        }, 300);
        await this.getMake();
        break;
      case 'Year of Registration':
        await this.onSelectYearOfReg(answer);
        const year = new Date().getFullYear();
        this.listYear = Array(30)
          .fill(0)
          // tslint:disable-next-line: radix
          .map((val, i) => parseInt(`${year - i}`));
        setTimeout(() => {
          this.closeSelectPopup();
          this.sharedConfig.setShowCustomLoader(false)
          this.showSelect(this.listYear, 'Year of Manufacture');
        }, 300);
        break;
      case 'Make':
        await this.onSelectMake(answer);
        setTimeout(() => {
          this.closeSelectPopup();
          this.sharedConfig.setShowCustomLoader(false)
          this.showSelect(this.models, 'Model');
        }, 300);
        break;
      case 'Model':
        await this.onSelectModel(answer);
       this.closeSelectPopup();
        break;
      case 'Vehicle Type':
        await this.onSelectVehicleType(answer);
        const thisYear = new Date().getFullYear();
        this.listYear = Array(30)
          .fill(0)
          // tslint:disable-next-line: radix
          .map((val, i) => parseInt(`${thisYear - i}`));
        setTimeout(() => {
          this.closeSelectPopup();
          this.sharedConfig.setShowCustomLoader(false)
          this.showSelect(this.listYear, 'Year of Registration');
        }, 300);
        break;
      default:
        break;
    }
  }

  closeSelectPopup() {
    this.showSelectPopup = false;
    SharedConfig.showFullScreen = false;
    SharedConfig.addingClaim = false;
    this.selectArray = [];
    this.popupHeading = '';
  }

  async getMake() {
    // (await this.loader).present();
    this.sharedConfig.setShowCustomLoader(true)
    this.makes = SharedConfig.selectedAssetVehicleMakes = await this.questionService.getVehicleMake(
      this.vehicleTypeCode,
      this.question.underwriting_answers[0].object_name,
      this.yearUnderwriting.object_answer
    );
    if (!this.makes || this.makes.length <= 0) {
      const alertNotFound = await this.alertCtrl.create({
        header: 'Something went wrong',
        message: 'Please try again later',
        buttons: [
          {
            text: 'OK',
            handler: () => {
              this.makes = null;
            },
          },
        ],
        backdropDismiss: false,
      });
      alertNotFound.present();
    }
    // (await this.loader).dismiss();
    this.sharedConfig.setShowCustomLoader(false)
  }

  onSelectVehicleType(asnwer: IVheicleType) {
    this.vehicleTypeUnderwriting.object_answer = asnwer.description
    this.vehicleTypeCode = asnwer.code
    if (this.yearUnderwriting.object_answer) {
      this.yearUnderwriting.object_answer = null;
      this.makeUnderwriting.object_answer = null;
      this.modelUnderwriting.object_answer = null;
    }
  }

  async getModel(make_code: string) {
    // let loader = this.loading.create();
    // (await loader).present();
    this.sharedConfig.setShowCustomLoader(true)
    if (make_code && this.yearUnderwriting.object_answer) {
      this.models = SharedConfig.selectedAssetVehicleModels = await this.questionService.getVehicleModel(
        this.vehicleTypeCode,
        this.question.underwriting_answers[0].object_name,
        make_code,
        this.yearUnderwriting.object_answer
      );
    }

    if (this.models.length <= 0) {
      this.closeSelectPopup();
      const alertNotFound = await this.alertCtrl.create({
        header: 'Nothing found',
        message: `No models was found for make ${this.makeUnderwriting.object_answer}`,
        buttons: [
          {
            text: 'OK',
            handler: () => {
              this.models = null;
            },
          },
        ],
        backdropDismiss: false,
      });
      alertNotFound.present();
    }
    // (await loader).dismiss();
    this.sharedConfig.setShowCustomLoader(false)
  }

  onSelectYearOfReg(year: number) {
    this.yearRegUnderwriting.object_answer = year;
    if (this.yearUnderwriting.object_answer) {
      this.yearUnderwriting.object_answer = null;
      this.makeUnderwriting.object_answer = null;
      this.modelUnderwriting.object_answer = null;
      this.makes = null;
      this.models = null;
      this.modelVariants = null;
    //  this.answerQuestion.emit(null);
    }
  }

  onSelectYear(year: number) {
    this.yearUnderwriting.object_answer = year;
    if (this.makeUnderwriting.object_answer) {
      this.makeUnderwriting.object_answer = null;
      this.modelUnderwriting.object_answer = null;
      this.makes = null;
      this.models = null;
      this.modelVariants = null;
    //  this.answerQuestion.emit(null);
    }
  }

  async onSelectMake(make: any) {
    this.makeUnderwriting.object_answer = make.description;
    if (this.modelUnderwriting.object_answer) {
      this.modelUnderwriting.object_answer = null;
      this.models = null;
     // this.answerQuestion.emit(null);
    }

    await this.getModel(make.code);
  }

  async onSelectModel(model: any) {
    this.modelUnderwriting.object_answer = model.description;
    this.question.underwriting_answers = [
      this.vehicleTypeUnderwriting,
      this.yearRegUnderwriting,
      this.yearUnderwriting,
      this.makeUnderwriting,
      this.modelUnderwriting
    ];
    this.answerQuestion.emit(this.question);
  }
}
